import { z } from "zod";
/**
 * Delegação por ausência (FASE-06-T48): quem está designado para a etapa ativa
 * registra um substituto por um período. Self-service — `delegatorSubject` é
 * sempre o ator autenticado.
 */
export const delegateWorkflowSchema = z
    .object({
    delegateSubject: z.string().trim().min(1).max(120),
    reason: z.string().trim().min(1).max(500),
    startAt: z.string().datetime().optional(),
    endAt: z.string().datetime().optional(),
})
    .refine((d) => !d.startAt || !d.endAt || d.startAt < d.endAt, {
    message: "startAt deve ser anterior a endAt",
    path: ["endAt"],
});
//# sourceMappingURL=delegate-workflow.js.map